'use strict';

angular.module('shiftTraderApp')
  .directive('saNoteReplies', ['$compile', 'NotesStore', 'saNoteDefaultVisibleReplies', 'saNoteReplyAbbreviationThreshold', '$q',
    function($compile, NotesStore, saNoteDefaultVisibleReplies, saNoteReplyAbbreviationThreshold, $q) {

    var tpl = '<div class="sa-note-replies">' +
        '<div class="sa-note-replies-container clearfix"><span class="loading-message">Loading replies...</span></div>' +
        '<div class="sa-note-reply-area">' +
          '<div sa-note-create="" mode="reply"></div>' +
        '</div>' +
      '</div>';

    var fullTemplate = '<div ng-repeat="reply in state.replies track by reply.id"><div sa-note="reply" indent="true"></div></div>';

    var abbrevTemplate = '<a href="javascript:void(0)" class="sa-note-reply-expander">' +
      '<i class="icon-caret-down"></i> Show All Replies' +
      '</a>' +
      '<div sa-note="reply" indent="true" ng-repeat="reply in state.previewReplies"></div>';

    return {
      restrict: 'A',
      template: tpl,
      scope: true,
      require: '^saNote',
      link: function(scope, element, attrs, parentCtrl) {
        var saNoteReplyAddedDereg, childScope;

        scope.state = {
          parentNoteId: parentCtrl.note.id,
          replies: undefined,
          isExpanded: null,
          renderRequired: true,
          previewReplies: []
        };


        function updateNoteReplies() {
          return NotesStore.getRepliesForNoteId(scope.state.parentNoteId)
            .then(function(noteReplies) {
              var lastRepliesLength = scope.state.replies && scope.state.replies.length || 0;
              scope.state.replies = noteReplies;

              if (_.isNull(scope.state.isExpanded)) {
                // if this is the first update, set the isExpanded state based on the threshold
                scope.state.isExpanded = !(scope.state.replies.length > saNoteReplyAbbreviationThreshold);
              }

              if (!scope.state.isExpanded) {
                if (lastRepliesLength < scope.state.replies.length) {
                  // we added a reply and we're not expanded, so show multiple in preview
                  var previousPreviewRepliesLength = scope.state.previewReplies && scope.state.previewReplies.length || 0;
                  scope.state.previewReplies = scope.state.replies.slice(-(saNoteDefaultVisibleReplies + previousPreviewRepliesLength));
                }
              }

              if (scope.state.renderRequired) {
                render();
              }
              return $q.resolve(true);

            }, function(response) {
              return $q.reject(response);
            });
        }



        var replaceTemplate = function(html) {
          var e = $(element)
            .find('> .sa-note-replies > .sa-note-replies-container');

          if (childScope) {
            childScope.$destroy();
          }

          childScope = scope.$new();

          e.html($compile(html)(childScope));
          return e;
        };

        var displayAllReplies = function() {
          scope.$evalAsync(function() {
            replaceTemplate(fullTemplate);
            if (saNoteReplyAddedDereg) {
              saNoteReplyAddedDereg();
            }
          })
        };

        function renderPreviewReplies() {
          replaceTemplate(abbrevTemplate)
            .find('.sa-note-reply-expander')
            .on('click', function() {
              scope.state.isExpanded = true;
              render();
            });
        }

        function render() {
          scope.state.renderRequired = false;
          if (scope.state.isExpanded) {
            // if we're not over the abbreviation threshold, render the template for showing all replies
            displayAllReplies();
          } else {
            // just show the last few replies
            renderPreviewReplies();
          }
        }


        scope.updateChannel = NotesStore.getNoteReplyChannelForNoteId(scope.state.parentNoteId);

        var subscription = scope.updateChannel.subscribe(function(note) {
          console.log('updatedNoteInReply', note);

          // see if we have this note in our array, if not, pull replies from cache again.
          var idx = _.findIndex(scope.state.replies, {id: note.id});
          if (idx < 0) {
            updateNoteReplies();
          }
        });

        updateNoteReplies();

        scope.$on('$destroy', function() {
          subscription.dispose();
          if (childScope) {
            childScope.$destroy();
          }

          childScope = undefined;
        });
      }
    }
  }]);
